var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');

function registerDevicesEvents() {

    // $('body').on('click', '.tt-test', function (e) {
    //     e.preventDefault();
    //
    // });
}

module.exports.registerDevicesEvents = registerDevicesEvents;
